/**
 * Priority/Status Colors - Universal across all entity types
 * These colors indicate urgency level, not entity type
 */
export const STATUS_COLORS = {
  overdue: '#D97757',     // Red-terracotta - immediate attention needed
  dueToday: '#C9A870',    // Warm taupe-gold - needs attention today
  upcoming: '#5B8E87',    // Sage green - scheduled/on track
  completed: '#9CA3AF',   // Gray - done/inactive

  // Entity-specific (exceptions only)
  appointment: '#7B9EAE', // Soft teal - ONLY for calendar/timeline views
} as const;

/**
 * Background colors for status badges (lighter variants)
 */
export const STATUS_BG_COLORS = {
  overdue: '#FEF2F0',
  dueToday: '#FBF7EF',
  upcoming: '#F0F5F4',
  completed: '#F3F4F6',
} as const;

export type StatusType = 'overdue' | 'dueToday' | 'upcoming' | 'completed';

interface ActionItemCounts {
  overdue: number;
  today: number;
  total?: number;
}

/**
 * Determines the appropriate status color based on item counts
 * Priority: overdue > dueToday > upcoming
 */
export function getStatusColor(item: ActionItemCounts): string {
  if (item.overdue > 0) return STATUS_COLORS.overdue;
  if (item.today > 0) return STATUS_COLORS.dueToday;
  return STATUS_COLORS.upcoming;
}

/**
 * Determines the status type based on item counts
 */
export function getStatusType(item: ActionItemCounts): StatusType {
  if (item.overdue > 0) return 'overdue';
  if (item.today > 0) return 'dueToday';
  return 'upcoming';
}

/**
 * Gets both status type and color for an item
 */
export function getItemStatus(item: ActionItemCounts) {
  const statusType = getStatusType(item);
  return {
    type: statusType,
    color: STATUS_COLORS[statusType],
    bgColor: STATUS_BG_COLORS[statusType],
  };
}
